// extracted by mini-css-extract-plugin
export default {"ticket":"_8IACr","ticketNamePrice":"t+MT5","description":"sX5T8"};